import React from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../Components/Sidebar/Sidebar";
import HeaderAdmin from "../../Components/HeaderAdmin/Header";

function EditCustomer() {
    return (

        <div>
            <div className="main-page-body-content-header">
                <HeaderAdmin />
            </div>
            <div className="dashboard-container d-flex">
                <div className="main-container">
                    <div className="main-page-body-content">
                        <div className="main-page-body-content-body">
                            <div className="main-page-body-content-body-container">
                                <div className="container-fluid">
                                    <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                        <h3>Customer Profile:</h3>
                                    </div>
                                    <div className="dashboard-sec">
                                        <div className="container-fulid">


                                            <div className="form-box-section mt-4">
                                                <div className="form-box-inner">
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Name</label>
                                                            <input type="text" className="form-control dashboard-input-box-1 me-1" placeholder="First" />
                                                            <input type="text" className="form-control dashboard-input-box-1" placeholder="Last" />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Email</label>
                                                            <input type="text" className="form-control dashboard-input-box-2" placeholder="Email Address" />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Phone</label>
                                                            <input type="text" className="form-control dashboard-input-box-3" placeholder="Phone Number" />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Height</label>
                                                            <div className="d-flex justify-content-end gap-2">
                                                                <input type="text" className="form-control dashboard-input-box w-30" placeholder="ft." />
                                                                <input type="text" className="form-control dashboard-input-box w-30" placeholder="in." />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Wrist to Floor</label>
                                                            <input type="text" className="form-control dashboard-input-box w-18" placeholder="in." />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Shoulder to Wrist</label>
                                                            <input type="text" className="form-control dashboard-input-box w-18" placeholder="in." />
                                                        </div>
                                                    </div>
                                                    <div className="form-item">
                                                        <div className="form-group custom-form-group">
                                                            <label className="dashboard-form-lable">Elbow to Wrist</label>
                                                            <input type="text" className="form-control dashboard-input-box w-18" placeholder="in." />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="sec-btn-group mt-4">
                                                <Link to="/customer-details">
                                                    <button className="btn btn-cancel">Exit without saving</button>
                                                </Link>
                                                <Link to="/customer-details">
                                                    <button className="btn btn-save">Update Customer</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div >
    );
}
export default EditCustomer;